module.exports = __webpack_public_path__ + "img/messageImage_01.jpg";